import { TotalSupplyAbi } from '../abis/shared'
import type { LstRegistryEntry } from '../registry'
import { ONE_E18, toBigInt, type LstReader } from './shared'

/**
 * Generic 1:1 BGT-wrapper reader (Infrared iBGT, BeraPaw LBGT, Bearn
 * yBGT, Stride stBGT).
 *
 * Berachain's BGT is non-transferable and earned via Proof-of-Liquidity;
 * these tokens are liquid wrappers backed 1:1 by BGT and do NOT accrue —
 * the value of 1 wrapper does not rise relative to 1 BGT. So there is no
 * exchange-rate getter to read: `exchangeRate` is fixed at 1e18 and
 * `totalAssets == totalSupply`. Only `totalSupply()` is fetched.
 */
export const readerBgtWrapper1to1 = (entry: LstRegistryEntry): LstReader => ({
  calls: [{ address: entry.address, name: 'totalSupply', params: [] }],
  abis: [TotalSupplyAbi],
  parse: ([supply]) => {
    const totalSupply = toBigInt(supply)
    if (totalSupply === undefined) return undefined
    return {
      totalAssets: totalSupply,
      totalSupply,
      exchangeRate: ONE_E18,
    }
  },
})
